class AutoScrollGallery extends HTMLElement {
  constructor() {
    super();
    this.splideInstance = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const sliderElement = this.querySelector('.splide');
    if (!sliderElement) return;

    const speed = parseFloat(this.dataset.speed) || 1;
    const pauseOnHover = this.dataset.pauseOnHover === 'true';
    const gap = parseInt(this.dataset.gap, 10) || 20;

    const options = {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      perPage: 5,
      gap: `${gap}px`,
      arrows: false,
      pagination: false,
      autoWidth: false,
      autoScroll: {
        speed: speed,
        pauseOnHover: pauseOnHover,
        pauseOnFocus: false,
      },
      breakpoints: {
        1200: { perPage: 4 },
        990: { perPage: 3 },
        750: { perPage: 2 },
        480: { perPage: 1.5, gap: `${Math.max(10, gap / 2)}px` },
      },
    };

    // Initialize Splide directly with globally available extensions
    const autoScrollExtension = window.splide?.Extensions?.AutoScroll || window.SplideAutoScroll;

    if (window.Splide && autoScrollExtension) {
      this.splideInstance = new window.Splide(sliderElement, options);
      this.splideInstance.mount({ AutoScroll: autoScrollExtension });
    }
  }

  disconnectedCallback() {
    if (this.splideInstance) {
      this.splideInstance.destroy();
    }
  }
}

if (!customElements.get('autoscroll-gallery')) {
  customElements.define('autoscroll-gallery', AutoScrollGallery);
}